import { Injectable } from "@angular/core";
import { Observable, from, of } from "rxjs";
import { switchMap, catchError } from "rxjs/operators";
import { Location } from "../models/location.model";
import { AzureMapService } from "../../azure-maps/azure-maps";

@Injectable({
  providedIn: "root",
})
export class GeolocationService {
  constructor(private azureMapService: AzureMapService) {}

  getCurrentLocation(): Observable<Location | null> {
    if (!navigator.geolocation) {
      return of(null);
    }

    return from(
      new Promise<GeolocationPosition>((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject);
      })
    ).pipe(
      switchMap(position => {
        const tempLocation = new Location();
        tempLocation.latitude = position.coords.latitude;
        tempLocation.longitude = position.coords.longitude;

        return this.azureMapService.reverseGeocode(tempLocation).pipe(
          switchMap(location => {
            if (location && location.address?.city && location.address?.stateProvince) {
              return of(location);
            }
            return of(null);
          }),
          catchError(() => of(null))
        );
      }),
      catchError(() => of(null))
    );
  }
}
